import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'lib-flexible'
// import echarts from 'echarts';
import * as echarts from 'echarts'
import F2 from "@antv/f2/lib/index-all";
import Vant from 'vant'
import 'vant/lib/index.css'
import FszBar from '@/components/Charts/FszBar'
import FszLine from '@/components/Charts/FszLine'
import FszPie from '@/components/Charts/FszPie'
import Notes from "@/components/notes.vue";
import Empty from '@/components/empty'
import ReportHead from "@/views/wx/components/reportHead.vue";
import '../public/iconfont.css'
import wx from 'weixin-js-sdk'

Vue.use(Vant,wx)
Vue.component('Empty', Empty)
Vue.component('ReportHead', ReportHead)
Vue.component('Notes', Notes)
Vue.component(FszBar.name, FszBar)
Vue.component(FszLine.name, FszLine)
Vue.component(FszPie.name, FszPie)
Vue.prototype.$echarts = echarts;
Vue.prototype.$F2 = F2;
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
// ceshi
